<template>
  <v-app :class="{ watermark: isStaging }">
    <v-toolbar
      v-if="$route.name != 'Loading'"
      app
      :clipped-left="clipped"
      color="primary"
      :class="{ watermarksm: isStaging }"
    >
      <v-toolbar-side-icon
        color="white--text"
        @click.stop="drawer = !drawer"
      ></v-toolbar-side-icon>
      <div>
        <img
          src="@/assets/images/vonexLogo.png"
          height="54px"
          style="padding: 9px; margin: 6px 0 0"
        />
      </div>
      <v-spacer></v-spacer>

      <app-status v-show="$route.name !== 'home'"></app-status>
      <v-spacer></v-spacer>
      <app-header></app-header>
    </v-toolbar>
    <v-content>
      <v-flex grow>
        <app-sidebar
          v-if="hasDealer && $route.name != 'Loading'"
          :drawer="drawer"
          :class="{ watermark: isStaging }"
        ></app-sidebar>
      </v-flex>

      <v-container fluid pa-0 ma-0>
        <!-- <app-status v-show="$route.name !== 'home'"></app-status> -->
        <router-view />
      </v-container>
      <app-note v-show="showNotes"></app-note>

      <v-footer :fixed="fixed" app>
        <span>
          &copy; {{ new Date().getFullYear() }} Copyright: vonex.com.au
        </span>
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import Header from './components/app-header';
import SideBar from './components/app-sidebar';
import Notification from './components/app-notification';

import Vue2Filters from 'vue2-filters';
import moment from 'moment';
import AppStatus from './components/app-status';
import '@/assets/site.css';
import VuejsDialog from 'vuejs-dialog';
//import VuejsDialogMixin from "vuejs-dialog/vuejs-dialog-mixin.min.js" // only needed in custom components
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import CustomerAddress from './components/customer-address';
import MessageAlert from './components/MessageAlert';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import AppNote from './components/app-note';
import Title from './components/title.vue';
import feature from 'vue-feature-toggle';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import { mapActions } from 'vuex';
import { httpError } from '@/models/httpError';
import VonexText from '@/components/VonexText';
import VonexDate from '@/components/VonexDate';
import VonexSelect from '@/components/VonexSelect';
import VonexAutocomplete from '@/components/VonexAutocomplete';
import VonexTextArea from '@/components/VonexTextArea';
import VonexCheckbox from '@/components/VonexCheckbox';
import VonexRadio from '@/components/VonexRadio';

import { HTTP } from './http-common';

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyCBg8UqAObAnfP9WivnIaEhR99b03CzCvA', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
});
const { mapGetters: mapOrderGetters } = createNamespacedHelpers(`orders`);
Vue.use(VuejsDialog);
Vue.use(Vue2Filters);

Vue.component('app-header', Header);
Vue.component('app-sidebar', SideBar);
Vue.component('app-notifications', Notification);

Vue.component('message-alert', MessageAlert);
Vue.component('date-picker', DatePicker);
Vue.component('v-title', Title);
Vue.component('app-note', AppNote);
Vue.component('AppStatus', AppStatus);
Vue.component('customer-address', CustomerAddress);
Vue.component('vonex-text', VonexText);
Vue.component(`vonex-date`, VonexDate);
Vue.component(`vonex-select`, VonexSelect);
Vue.component(`vonex-autocomplete`, VonexAutocomplete);
Vue.component(`vonex-textarea`, VonexTextArea);
Vue.component(`vonex-checkbox`, VonexCheckbox);
Vue.component(`vonex-radio`, VonexRadio);

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  }
});

Vue.filter('orderStatus', function (value) {
  switch (value) {
    case 0:
      return 'New';
    case 1:
      return 'In Progress';
    case 2:
      return 'Signed';
    case 3:
      return 'Completed';
    case 4:
      return 'Cancelled';
    case 5:
      return 'Rejected';
    default:
      return 'Unknown';
  }
});

Vue.component('feature', feature);

export default {
  name: 'Root',

  data() {
    return {
      clipped: true,
      fixed: true,
      title: 'Vonex',
      drawer: true,
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {
    ...mapActions('orders', ['getDealerFromEmail']),
    ...mapActions('orders/auth', ['setAuth', 'setMessage']),
  },
  watch: {
    /*eslint-disable */
    '$auth.isAuthenticated': async function (newStatus, oldStatus) {
      let vm = this;

      let token = await vm.$auth.getTokenSilently();
      if (newStatus) {
        let response = await this.$auth.getIdTokenClaims();
        vm.setAuth(response);
        vm.authorising = true;
        var loginInfo = await HTTP.get(`Impersonate/GetLoginInfo`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        //featureflags
        let user = {
          key: vm.$auth.user.email,
          firstName: vm.$auth.user.nickname,
          email: vm.$auth.user.email,
        };
        vm.$ld.identify({ newUser: user }, function () {
          vm.$store.commit('orders/setQuoteToolFlag', vm.$ld.flags.quoteTool);
          vm.$store.commit('orders/setFlags', vm.$ld.flags);
        });
      }
      vm.getDealerFromEmail().then((data) => {
        let user = {
          key: vm.dealer.dealerEmail,
          fullName: vm.dealer.dealerFullName,
          email: vm.dealer.dealerEmail,
        };
        let invalid =
          !data ||
          !['DirectSales', 'Admin', 'Dealer', 'Employee'].includes(
            data.authLevel
          );
        if (invalid) {
          this.$router.push('/unauthorized');
        }
        //NOTE: COMMENTED OUT TO AVOID ANY QUOTE TOOL FLAG TO BE ACTIVATED
        vm.$ld.identify({ newUser: user }, function () {
          vm.$store.commit('orders/setQuoteToolFlag', vm.$ld.flags.quoteTool);
          vm.$store.commit('orders/setFlags', vm.$ld.flags);
        });
        if (
          vm.dealer.authLevel &&
          vm.dealer.authLevel.toLowerCase() == 'interested'
        ) {
          this.$router.push('/unauthorized');
        }
      });
      vm.authorising = false;
      vm.$ga.set('userId', loginInfo.data.ubDealerID);

      if (!vm.viewbarEnabled) {
        if (loginInfo.data.isImpersonating) {
          vm.isImpersonating(loginInfo.data.impersonatedID).then((x) => {
            vm.setImpersonatingAs(x.data);
            vm.enableViewBar();
          });
        }
      }
    },
    '$ld.flags': function () {
      let vm = this;

      vm.$store.commit('orders/setQuoteToolFlag', vm.$ld.flags.quoteTool);
      vm.$store.commit('orders/setFlags', vm.$ld.flags);
    },
  },
  computed: {
    ...mapOrderGetters(['hasDealer', 'isAdmin', 'quoteToolFlag']),
    showNotes() {
      return ['Summary', 'OrderApprove'].indexOf(this.$route.name) < 0;
    },
    isStaging() {
      return (
        process.env.NODE_ENV == 'staging' ||
        process.env.NODE_ENV == 'development'
      );
    },
  },
  mounted() {
    this.$store.commit('orders/changeLessee/setCreateOnly', false);
    this.$store.commit('orders/changeLessee/setProcessingChangeOfLesse', false);
  },
};
</script>
<style>
.watermark {
  background: url('https://vonex.com.au/vonex/projects/watermark-blck.png')
    repeat !important;
}
.watermarksm {
  background: url('https://vonex.com.au/vonex/projects/watermark-small.png')
    repeat !important;
}
.v-input--selection-controls__input input[type='checkbox'],
.v-input--selection-controls__input div.v-input--selection-controls__ripple {
  z-index: 5 !important;
}
</style>
